import { ApiMask, updateApiMask } from '../../../logger/BitMask';
import { Fetcher } from '../../Fetcher';

import { casinoConfigEndpoint } from './endpoints';
import { CasinoConfigType } from './types';

export interface FetchCasinoConfigParams {
  JSESSIONID: string;
  baseUrl: string;
  language?: string;
}

export const fetchCasinoConfig = ({
  JSESSIONID,
  baseUrl,
  language,
}: FetchCasinoConfigParams): Promise<CasinoConfigType> => {
  const params: Record<string, string> = {
    JSESSIONID,
  };

  if (language) {
    params.ln = language;
  }

  return Fetcher.fetch<unknown>(`${baseUrl}${casinoConfigEndpoint.url}`, {
    params,
    format: casinoConfigEndpoint.format,
  }).then((result: unknown) => {
    const parsedResult = casinoConfigEndpoint.parser(result, undefined);

    updateApiMask(ApiMask.CasinoConfig);
    return parsedResult;
  });
};
